import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { BaseService } from '../../services/base.service';
import { Menus } from './menus';

@Injectable()
export class MenuService extends BaseService {
    constructor(private http: HttpClient) { super(); }

    private menuSource = new Subject<string>();
    private resetSource = new Subject();

    menuSource$ = this.menuSource.asObservable();
    resetSource$ = this.resetSource.asObservable();

    onMenuStateChange(key: string) {
        this.menuSource.next(key);
    }

    reset() {
        this.resetSource.next();
    }

    getByRole(): Observable<Menus[]> {
        return this.http.get<Menus[]>(this.getUrl(`Menus/GetByRole`));
    }
}
